import "./App.css";
import SideBar from "./components/Sidebar/SideBar";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import About from "./pages/About";
import Filters from "./pages/Filters";
function App() {
  return (
    <Router>
      <SideBar>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/filter" element={<Filters />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<>404 not found</>} />
        </Routes>
      </SideBar>
    </Router>
  );
}

export default App;
